module.exports = __webpack_public_path__ + "img/Applebees_logo.9f975355.svg";